var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.inLoading)?_c('div',[_c('VerticalAlert'),_vm._v(" "),_c('nuxt')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }